import React, { useState, useEffect } from "react";
import ComplaintIcon from './child/ComplaintIcon';
import axios from 'axios'; 
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { useNavigate, useLocation } from "react-router-dom";
import { getMediaUrl } from "../utils/uploadService";
import ComplaintUploadWithImagePreviewList from "./child/ComplaintUploadWithImagePreviewList";
import SearchableSelect from "./child/SearchableSelect";
import { ClipboardText, FilePdf, ArrowLeft, ShieldCheck } from '@phosphor-icons/react';
import './ComplaintReview.css';
import ComplaintEvidenceDialog from './child/ComplaintEvidenceDialog';
import RegistrationSelect from './child/RegistrationSelect';
import './ComplaintRegistration.css';
import OfficerRoleIcon from './child/OfficerRoleIcon';
const Icon = (props) => <ComplaintIcon weight="duotone" aria-hidden="true" {...props} />;
const isDepartmentHead = (officer) => /^secretary\b.*(?:forest|wildlife)/i.test(String(officer.designation || '').trim());

const IndividualOfficerChoice = ({ officer, selectedId, onChange, disabled }) => {
  const officerId = String(officer._id);
  const selected = selectedId === officerId;
  const officerName = `${officer.first_name || ''} ${officer.last_name || ''}`.trim();
  const head = isDepartmentHead(officer);
  return (
    <div className="col-lg-3 col-md-4 col-sm-6">
      <div className={`form-check card border h-100 ${selected ? 'border-success bg-success-50' : ''}`}>
        <div className="card-body p-3">
          <input className="form-check-input" type="radio" name="officerSelection" id={`unassigned-dfo-${officerId}`} checked={selected} onChange={() => onChange(officerId)} disabled={disabled} />
          <label className="form-check-label d-flex align-items-center gap-2 w-100 h-100 officer-choice-label" htmlFor={`unassigned-dfo-${officerId}`}>
            <OfficerRoleIcon role={head ? 'SECRETARY' : 'INDIVIDUAL'} />
            <div><span className={`d-block ${selected ? 'fw-bold text-success' : 'text-muted'}`}>{head ? 'Secretary Forest & Wildlife' : officerName || officer.designation}</span>
              {head ? <small className="text-secondary-light">{officerName || 'Head of department'}</small> : officer.designation && officer.designation !== officerName && <small className="text-secondary-light">{officer.designation}</small>}
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};
const ComplainFormPageCloseUpdate = ({ complainId, listPath = "/closed/list" }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const authUserId = storedUser._id;
  const navigate = useNavigate();
  const location = useLocation();

  const [formDataForest, setFormDataForest] = useState({
    complaintAction: 'Resolve',
    closeRemarks: '',
    reopenRemarks: '',
    // "Probe Cases" capture fields
    inquiryDescription: '',
    inquiryRemarks: '',
    probeResolutionDays: ''
  });
  
  const [officerChecklist, setOfficerChecklist] = useState({
    DFO: false,
    CF: false,
    CCF: false,
    DG: false,
    SO_FOREST: false,
    AS_ADMIN: false,
    AS_TECH: false,
    AS_PMAE: false,
    GIS_LAB_MANAGER: false,
    DS_WILDLIFE: false,
    DCWR_LAHORE_HQ: false
  });
  const [reopenOfficers, setReopenOfficers] = useState([]);
  const [selectedOfficerId, setSelectedOfficerId] = useState("");
  const [unassignedDfoUsers, setUnassignedDfoUsers] = useState([]);
  const [selectedUnassignedDfoId, setSelectedUnassignedDfoId] = useState("");
  const [isLoadingOfficers, setIsLoadingOfficers] = useState(false);
  // Optional attachment(s) uploaded alongside the re-open remarks.
  const [reopenMediaUrls, setReopenMediaUrls] = useState([]);
  // Attachment(s) uploaded with the "Probe Cases" details.
  const [inquiryMediaUrls, setInquiryMediaUrls] = useState([]);
  
  const [formData, setFormData] = useState({
    dept_id: "",
    dept_name: "",
    district_id: "",
    complaint_district_name: "",
    complaint_number: "",
    complaint_nature_id: "",
    complaint_nature_name: "",
    complaint_nearby_place: "",
    complaint_detail: "",
    complainant_name: "",
    complainant_address: "",
    complainant_contact_no: "",
    complainant_email: "",
    complaint_time: "",
    complaint_additional_remarks: "",
    complainant_phone_secondry: "",
    other_nature: "",
    received_by: "",
    status: "Open",
    priority_level: "",
    cnic: "",
    complaint_source: "",
    complainant_city: "",
    complainant_tehsil: "",
    complainant_district: "",
    complaint_city: "",
    complaint_tehsil: "",
    complaint_district: "",
    complaint_address: "",
    media_array: [],
    statusHistory: [],
    // Existing "Probe Cases" capture (description, remarks, media_array, at, by),
    // shown read-only when the complaint has already been moved to Probe Cases.
    under_inquiry: null,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const [showClosingEvidenceModal, setShowClosingEvidenceModal] = useState(false);

  const officerConfig = {
    DFO: { label: "DCF", icon: "mdi:account-tie", color: "primary" },
    CF: { label: "CF", icon: "mdi:account-tie-hat", color: "success" },
    CCF: { label: "CCF", icon: "mdi:account-tie-voice", color: "warning" },
    DG: { label: "DG", icon: "mdi:account-tie-woman", color: "danger" },
    SO_FOREST: { label: "SO Forest", icon: "mdi:forest", color: "success" },
    AS_ADMIN: { label: "AS Admin", icon: "mdi:office-building", color: "info" },
    AS_TECH: { label: "AS Tech", icon: "mdi:cogs", color: "secondary" },
    AS_PMAE: { label: "AS PM&E", icon: "mdi:chart-bar", color: "primary" },
    GIS_LAB_MANAGER: { label: "Manager GIS Lab", icon: "mdi:map-marker-radius", color: "success" },
    DS_WILDLIFE: { label: "DS Wildlife", icon: "mdi:paw", color: "success" },
    DCWR_LAHORE_HQ: { label: "DCWR Lahore HQ", icon: "mdi:office-building-marker", color: "info" }
  };

  useEffect(() => {
    const fetchComplaintData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaints/${complainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          const complaintData = response.data.data;
          setFormData({
            dept_id: complaintData.dept_id?._id || "",
            dept_name: complaintData.dept_id?.name || "",
            complaint_number: complaintData.complaint_number || "",
            district_id: complaintData.complaint_district_id?._id || "",
            complaint_nature_id: complaintData.complaint_nature_id?._id || "",
            complaint_nature_name: complaintData.complaint_nature_id?.name || "",
            complaint_nearby_place: complaintData.near_by_place || "",
            complaint_detail: complaintData.complaint_detail || "",
            complainant_name: complaintData.complainant_name || "",
            complainant_address: complaintData.complainant_address || "",
            complainant_contact_no: complaintData.complainant_contact_no || "",
            complainant_email: complaintData.complainant_email || "",
            complaint_time: complaintData.time_of_call || "",
            complaint_additional_remarks: complaintData.remarks || "",
            complainant_phone_secondry: complaintData.complainant_contact_no_sec || "",
            other_nature: complaintData.other_nature || "",
            received_by: `${complaintData.received_by?.first_name || ''} ${complaintData.received_by?.last_name || ''}`.trim() || "",
            status: complaintData.status || "Open",
            priority_level: complaintData.priority_level || "",
            cnic: complaintData.complainant_cnic || "",
            complaint_source: complaintData.complaint_source || "",
            complainant_city: complaintData.complainant_city_id?.name || "",
            complainant_tehsil: complaintData.complainant_tehsil_id?.name || "",
            complainant_district: complaintData.complainant_district_id?.name || "",
            complaint_city: complaintData.complaint_city_id?.name || "",
            complaint_tehsil: complaintData.complaint_tehsil_id?.name || "",
            complaint_district: complaintData.complaint_district_id?.name || "",
            complaint_address: complaintData.complaint_address || "",
            lat: complaintData.lat || "",
            long: complaintData.long || "",
            assigned_to: `${complaintData.assigned_to?.first_name || ''} ${complaintData.assigned_to?.last_name || ''}`.trim() || "",
            dispatched_time: complaintData.dispatched_time || "",
            referred_by: complaintData.referred_by || "",
            dfo_remarks: complaintData.dfo_remarks || "",
            cancel_reason: complaintData.cancel_reason || "",
            media_array: complaintData.media_array || [],
            statusHistory: complaintData.statusHistory || [],
            under_inquiry: complaintData.under_inquiry || null,
            persons_in_loop: complaintData.persons_in_loop || [],
            assigned_to_phone: complaintData.assigned_to?.phone_no || "",
            complaint_division_name: complaintData.complaint_forest_division_id?.name || complaintData.complaint_district_id?.name || "",
          });

          if (complaintData.status === 'In Progress' || complaintData.status === 'Escalated') {
            setFormDataForest(prev => ({ ...prev, complaintAction: 'Probe Cases' }));
          }
        }
      } catch (error) {
        toast.error("Failed to fetch complaint data.");
        console.error("Error fetching complaint data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplaintData();
  }, [API_BASE_URL, complainId, authUserId]);

  const handleChecklistChange = (selectedOfficer) => {
    setSelectedUnassignedDfoId("");
    setSelectedOfficerId("");
    setReopenOfficers([]);
    setOfficerChecklist(prev => {
      const newChecklist = Object.keys(prev).reduce((acc, officer) => {
        acc[officer] = false;
        return acc;
      }, {});
      newChecklist[selectedOfficer] = !prev[selectedOfficer];
      return newChecklist;
    });
  };

  useEffect(() => {
    const fetchUnassignedDfoUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/backend/complaints/reopen-officers/UNASSIGNED_DFO`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUnassignedDfoUsers(response.data?.data || []);
      } catch (error) {
        setUnassignedDfoUsers([]);
        console.error("Failed to fetch hierarchy-less DFO users:", error);
      }
    };

    fetchUnassignedDfoUsers();
  }, [API_BASE_URL]);

  const handleUnassignedDfoChange = (userId) => {
    setOfficerChecklist(prev => Object.keys(prev).reduce((acc, officer) => {
      acc[officer] = false;
      return acc;
    }, {}));
    setSelectedOfficerId("");
    setReopenOfficers([]);
    setSelectedUnassignedDfoId(prev => prev === userId ? "" : userId);
  };

  useEffect(() => {
    const selectedHierarchyType = officerChecklist.DFO
      ? "DCF"
      : officerChecklist.CF
        ? "CF"
        : officerChecklist.CCF
          ? "CCF"
          : null;

    if (!selectedHierarchyType) return;

    const fetchReopenOfficers = async () => {
      setIsLoadingOfficers(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/backend/complaints/reopen-officers/${selectedHierarchyType}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setReopenOfficers(response.data?.data || []);
      } catch (error) {
        setReopenOfficers([]);
        toast.error(error.response?.data?.message || `Failed to fetch ${selectedHierarchyType} officers.`);
      } finally {
        setIsLoadingOfficers(false);
      }
    };

    fetchReopenOfficers();
  }, [API_BASE_URL, officerChecklist.DFO, officerChecklist.CF, officerChecklist.CCF]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataForest(prev => ({ ...prev, [name]: value }));
  };

  const getPriorityClasses = (priority) => {
    switch (priority) {
      case "Low":
        return "bg-info-focus text-info-600";
      case "Medium":
        return "bg-success-focus text-success-600";
      case "High":
        return "bg-warning-focus text-warning-600";
      case "Critical":
        return "bg-danger-focus text-danger-600";
      default:
        return "bg-secondary text-secondary-600";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token not found. Please login again.");
      setIsSubmitting(false);
      return;
    }

    const effectiveListPath = location.state?.listPath || (formData.status === 'In Progress' || formData.status === 'Escalated' ? '/assigned/list' : listPath);

    if (formDataForest.complaintAction === 'Resolve') {
      if (!formDataForest.closeRemarks) {
        toast.error("Please provide remarks for resolving the complaint!");
        setIsSubmitting(false);
        return;
      }

      try {
        const statusData = {
          id: complainId,
          feedback_text: formDataForest.closeRemarks,
          status: "Resolved",
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/complainant-feedback`,
          statusData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          // Stage 5 — Resolved: SMS to assigned officer + officers in loop
          try {
            const resolvedDate = new Date().toLocaleDateString('en-GB');
            if (formData.assigned_to_phone) {
              const officerSms = `Dear Sir, your complaint ${formData.complaint_number} regarding '${formData.complaint_nature_name}' has been RESOLVED on ${resolvedDate}. Thank you for helping protect Punjab's forests & wildlife.`;
              await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
                params: {
                  sec_key: process.env.REACT_APP_PITB_KEY,
                  sms_text: officerSms,
                  phone_no: formData.assigned_to_phone,
                  sms_language: 'english'
                }
              });
            }

            const loopPhones = new Set((formData.persons_in_loop || []).map(p => p.phone_no).filter(Boolean));
            if (formData.assigned_to_phone) loopPhones.delete(formData.assigned_to_phone);
            if (loopPhones.size > 0) {
              const loopSms = `Dear Sir, complaint ${formData.complaint_number} ('${formData.complaint_nature_name}', ${formData.complaint_division_name}) has been resolved.`;
              await Promise.all(Array.from(loopPhones).map(phone =>
                axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
                  params: {
                    sec_key: process.env.REACT_APP_PITB_KEY,
                    sms_text: loopSms,
                    phone_no: phone,
                    sms_language: 'english'
                  }
                })
              ));
            }
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          // Status change: SMS to admin (03379926560)
          try {
            const statusSms = `Dear Sir, complaint ${formData.complaint_number} ('${formData.complaint_nature_name}') status has been changed from ${formData.status} to Resolved.`;
            await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
              params: {
                sec_key: process.env.REACT_APP_PITB_KEY,
                sms_text: statusSms,
                phone_no: "03379926560",
                sms_language: 'english'
              }
            });
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          toast.success("Complaint resolved successfully!");
          navigate(effectiveListPath, { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to resolve complaint.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to resolve complaint.");
        console.error("Error resolving complaint:", postError);
      } finally {
        setIsSubmitting(false);
      }
    } else if (formDataForest.complaintAction === 'Probe Cases') {
      const resolutionDays = Number(formDataForest.probeResolutionDays);
      if (!formDataForest.inquiryDescription || !formDataForest.inquiryRemarks) {
        toast.error("Please provide the inquiry description and remarks!");
        setIsSubmitting(false);
        return;
      }
      if (!Number.isInteger(resolutionDays) || resolutionDays < 1) {
        toast.error("Please provide a valid number of days for resolving the probe!");
        setIsSubmitting(false);
        return;
      }

      try {
        const statusData = {
          id: complainId,
          description: formDataForest.inquiryDescription,
          remarks: formDataForest.inquiryRemarks,
          number_of_days: resolutionDays,
          media_array: inquiryMediaUrls, // optional attachment(s)
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/mark-under-inquiry`,
          statusData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          // Stage 4 — Put Under Probe: SMS to assigned officer
          try {
            if (formData.assigned_to_phone) {
              const probeSms = `Dear Sir, Complaint ${formData.complaint_number} has been placed under probe. Further inquiry required: ${formDataForest.inquiryRemarks}`;
              await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
                params: {
                  sec_key: process.env.REACT_APP_PITB_KEY,
                  sms_text: probeSms,
                  phone_no: formData.assigned_to_phone,
                  sms_language: 'english'
                }
              });
            }
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          // Status change: SMS to admin (03379926560)
          try {
            const statusSms = `Dear Sir, complaint ${formData.complaint_number} ('${formData.complaint_nature_name}') status has been changed from ${formData.status} to Probe Cases.`;
            await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
              params: {
                sec_key: process.env.REACT_APP_PITB_KEY,
                sms_text: statusSms,
                phone_no: "03379926560",
                sms_language: 'english'
              }
            });
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          toast.success("Complaint moved to Probe Cases successfully!");
          navigate(effectiveListPath, { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to move complaint to Probe Cases.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to move complaint to Probe Cases.");
        console.error("Error moving complaint to Probe Cases:", postError);
      } finally {
        setIsSubmitting(false);
      }
    } else if (formDataForest.complaintAction === 'Re-Open') {
      if (!formDataForest.reopenRemarks) {
        toast.error("Please provide remarks for re-opening the complaint!");
        setIsSubmitting(false);
        return;
      }

      const selectedOfficers = [
        ...Object.values(officerChecklist).filter(Boolean),
        ...(selectedUnassignedDfoId ? [true] : []),
      ];
      if (selectedOfficers.length === 0) {
        toast.error("Please select one officer for the checklist!");
        setIsSubmitting(false);
        return;
      }

      if (selectedOfficers.length > 1) {
        toast.error("Please select only one officer at a time!");
        setIsSubmitting(false);
        return;
      }

      const isHierarchyOfficer = officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF;
      if (isHierarchyOfficer && !selectedOfficerId) {
        toast.error("Please select an officer from the dropdown!");
        setIsSubmitting(false);
        return;
      }

      try {
        const statusData = {
          complaintId: complainId,
          reason: formDataForest.reopenRemarks,
          selectedOfficerId: selectedUnassignedDfoId || selectedOfficerId,
          media_array: reopenMediaUrls, // optional attachment(s)
          ...officerChecklist,
          DFO: officerChecklist.DFO || Boolean(selectedUnassignedDfoId),
        };

        const response = await axios.post(
          `${API_BASE_URL}/backend/complaints/repen-complaint`,
          statusData,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            timeout: 10000,
          }
        );

        if (response.data.status) {
          // Stage 6 — Reopened: SMS to newly assigned officer
          try {
            const newOfficerPhone = response.data.data?.newAssignedTo?.phone;
            if (newOfficerPhone) {
              const reopenSms = `Dear Sir, complaint ${formData.complaint_number} ('${formData.complaint_nature_name}', ${formData.complaint_division_name}) has been RE-OPENED and assigned to you. Reason: ${formDataForest.reopenRemarks}. Please take action.`;
              await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
                params: {
                  sec_key: process.env.REACT_APP_PITB_KEY,
                  sms_text: reopenSms,
                  phone_no: newOfficerPhone,
                  sms_language: 'english'
                }
              });
            }
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          // Status change: SMS to admin (03379926560)
          try {
            const statusSms = `Dear Sir, complaint ${formData.complaint_number} ('${formData.complaint_nature_name}') status has been changed from ${formData.status} to Reopened.`;
            await axios.post('https://smsgateway.pitb.gov.pk/api/send_sms', null, {
              params: {
                sec_key: process.env.REACT_APP_PITB_KEY,
                sms_text: statusSms,
                phone_no: "03379926560",
                sms_language: 'english'
              }
            });
          } catch (smsError) {
            console.error("Error sending SMS:", smsError);
          }

          toast.success("Complaint re-opened successfully!");
          navigate(effectiveListPath, { state: { showToast: true } });
        } else {
          toast.error(response.data.message || "Failed to re-open complaint.");
        }
      } catch (postError) {
        toast.error(postError.response?.data?.message || "Failed to re-open complaint.");
        console.error("Error re-opening complaint:", postError);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Handler for Back button
  const handleBack = () => {
    const effectiveListPath = location.state?.listPath || (formData.status === 'In Progress' || formData.status === 'Escalated' ? '/assigned/list' : listPath);
    navigate(effectiveListPath);
  };

  // Handler for Export PDF button
  const handleExportPDF = () => {
    window.open(`/complains/view/${complainId}`, '_blank');
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const latestStatusHistory = [...formData.statusHistory]
    .reverse()
    .find((entry) => entry.status === 'Closed') || null;

  // Probe Case details, merged from the dedicated under_inquiry field and, as a
  // fallback, the latest "Probe Cases" status-history row (older probe records
  // stored the data only on the history row). Empty fields are dropped so the
  // panel never shows a wall of "No Data Found".
  const probeHistory = [...formData.statusHistory]
    .reverse()
    .find((entry) => entry.status === 'Probe Cases') || null;
  const ui = formData.under_inquiry || {};
  const probeMedia = (Array.isArray(ui.media_array) && ui.media_array.length > 0)
    ? ui.media_array
    : (Array.isArray(probeHistory?.userMediaArray) ? probeHistory.userMediaArray : []);
  const probeInfo = {
    description: ui.description || probeHistory?.dfo_remarks || '',
    remarks: ui.remarks || probeHistory?.userRemarks || probeHistory?.reason || '',
    by: ui.by || probeHistory?.name || probeHistory?.by || '',
    at: ui.at || probeHistory?.changedAt || '',
    media: probeMedia,
  };
  const probeRows = [
    { label: 'Inquiry Description', icon: 'mdi:text-box-search-outline', value: probeInfo.description },
    { label: 'Inquiry Remarks', icon: 'mdi:comment-text', value: probeInfo.remarks },
    { label: 'Moved to Probe By', icon: 'mdi:account', value: probeInfo.by },
    { label: 'Probe Date', icon: 'mdi:clock-history', value: probeInfo.at ? new Date(probeInfo.at).toLocaleString() : '' },
  ].filter((r) => r.value);
  const hasProbeData = probeRows.length > 0 || probeInfo.media.length > 0;

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 complaint-review-page">
      <ToastContainer />
      
      <div className="text-center"></div>
      
      <div className="card-body py-10">
        <header className="review-page-heading">
          <span className="review-page-emblem"><ClipboardText size={30} weight="duotone" aria-hidden="true" /></span>
          <div><span className="review-eyebrow">Complaint management</span><h1>Complaint Review</h1><p>Review the complete record and choose the appropriate next action.</p></div>
          <span className="review-status">{formData.status || 'Complaint record'}</span>
        </header>
        {/* Buttons Section */}
        <div className="d-flex justify-content-between mb-4 review-toolbar">
          <button
            className="btn btn-success-500 btn-md px-6 py-6 radius-8"
            onClick={handleBack}
          >
            <ArrowLeft size={17} className="me-2" aria-hidden="true" />
            Back
          </button>
          <button
            className="btn btn-success-900 btn-md px-6 py-6 radius-8"
            onClick={handleExportPDF}
          >
            <FilePdf size={18} className="me-2" weight="duotone" aria-hidden="true" />Export PDF
          </button>
        </div>
        {/* End Buttons Section */}

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="shadow-4 border radius-8 review-workspace">
              <div className="p-20 border-bottom fs-5 review-summary">
                <div className="review-panel-heading"><h2>Complaint overview</h2><span>Reference &amp; location</span></div>
                <div className="row justify-content-between g-3">
                  <div className="col-sm-6">
                    <h4 className="mb-20 review-reference">{formData.complaint_number} <span className={`px-3 py-1 rounded-pill fw-semibold text-xl ${getPriorityClasses(formData.priority_level)}`}>
                      {formData.priority_level || 'No Data Found'}
                    </span></h4>
                    <div className="space-y-2">
                      {[
                        { label: 'Complaint Time', icon: 'mdi:clock-outline', value: formData.complaint_time ? new Date(formData.complaint_time).toLocaleString() : 'No Data Found' },
                        { label: 'Department', icon: 'mdi:office-building', value: formData.dept_name },
                        {
                          label: 'Source of Complaint',
                          icon: 'mdi:source-branch',
                          value: formData.complaint_source
                        },
                        {
                          label: 'Nature of Complaint',
                          icon: 'mdi:alert-circle',
                          value: (
                            <>
                              {formData.complaint_nature_name}
                              {formData.complaint_nature_name === 'Other' && formData.other_nature && (
                                <span className="ms-2 text-muted fst-italic">({formData.other_nature})</span>
                              )}
                            </>
                          )
                        },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex justify-content-between">
                          <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                            <Icon icon={icon} /> {label}
                          </span>
                          <span className="col-1">:</span>
                          <span className="col-7 text-decoration-underline">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-sm-6 space-y-2">
                    {[
                      { label: 'Nearby Place', icon: 'mdi:map-marker', value: formData.complaint_nearby_place },
                      { label: 'Complaint Tehsil', icon: 'mdi:map', value: formData.complaint_tehsil },
                      { label: 'Complaint District', icon: 'mdi:map-outline', value: formData.complaint_district },
                      { label: 'Complaint Address', icon: 'mdi:home-map-marker', value: formData.complaint_address },
                      { label: 'Received By', icon: 'mdi:account', value: formData.received_by },
                    ].map(({ label, icon, value }, index) => (
                      <div key={index} className="d-flex justify-content-between">
                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                          <Icon icon={icon} /> {label}
                        </span>
                        <span className="col-1">:</span>
                        <span className="col-7 text-decoration-underline">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:clipboard-text" />Complaint Details
                    </h6>
                    <p>{formData.complaint_detail || 'No Data Found'}</p>
                    {formData.media_array?.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-success-600 mt-2"
                        onClick={() => setShowAttachmentsModal(true)}
                      >
                        Show Evidence
                      </button>
                    )}
                  </div>
                </div>
              </div>
              
              <hr/>
              
              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-12 mt-3">
                    <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                      <Icon icon="mdi:text" />Additional Remarks
                    </h6>
                    <p>{formData.complaint_additional_remarks || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              
              <hr/>

              {(formData.status === 'In Progress' || formData.status === 'Escalated') && (
                <div className="py-28 px-20">
                  <div className="row fs-5">
                    <div className="col-12 mt-3">
                      <h6 className="mb-3 text-primary-600 d-flex align-items-center gap-1 col-4 fw-bold">
                        <Icon icon="mdi:account-arrow-right" /> Assignment Details
                      </h6>
                      <div className="space-y-2">
                        {[
                          { label: 'Current Status', icon: 'mdi:progress-clock', value: `${formData.status} (Awaiting Field Reply)` },
                          { label: 'Assigned Officer', icon: 'mdi:account-tie', value: formData.assigned_to || 'Officer Assigned' },
                          { label: 'Dispatched At', icon: 'mdi:clock-time-four-outline', value: formData.dispatched_time ? new Date(formData.dispatched_time).toLocaleString() : 'N/A' },
                        ].map(({ label, icon, value }, index) => (
                          <div key={index} className="d-flex justify-content-between">
                            <span className="text-primary-600 d-flex align-items-center gap-1 col-4 fw-bold">
                              <Icon icon={icon} /> {label}
                            </span>
                            <span className="col-1">:</span>
                            <span className="col-7 text-decoration-underline">{value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {(formData.status === 'Closed' || formData.status === 'Probe Cases') && latestStatusHistory && (
                <div className="py-28 px-20">
                  <div className="row fs-5">
                    <div className="col-12 mt-3">
                      <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold">
                        <Icon icon="mdi:clipboard-check-outline" />Complaint Closing Details
                      </h6>
                      <div className="space-y-2">
                        {[
                          { label: 'Closed By', icon: 'mdi:account', value: latestStatusHistory.by || 'No Data Found' },
                          // Officer name & contact intentionally hidden.
                          // { label: 'Officer Name', icon: 'mdi:account-tie', value: latestStatusHistory.name || 'No Data Found' },
                          // { label: 'Officer Contact #', icon: 'mdi:phone', value: latestStatusHistory.phoneNo || 'No Data Found' },
                          { label: 'Email', icon: 'mdi:email', value: latestStatusHistory.dfoEmail || latestStatusHistory.email || 'No Data Found' },
                          { 
                            label: 'Closure Evidence',
                            icon: 'mdi:paperclip', 
                            value: latestStatusHistory.userMediaArray?.length > 0 ? (
                              <button
                                type="button"
                                className="btn btn-sm btn-success-600 mx-20"
                                onClick={() => setShowClosingEvidenceModal(true)}
                              >
                                Show Attachments
                              </button>
                            ) : 'No Attachment Available'
                          },
                          { label: 'Remarks', icon: 'mdi:comment-text', value: latestStatusHistory.userRemarks || latestStatusHistory.dfo_remarks || 'No Data Found' },
                        ].map(({ label, icon, value }, index) => (
                          <div key={index} className="d-flex justify-content-between">
                            <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                              <Icon icon={icon} /> {label}
                            </span>
                            <span className="col-1">:</span>
                            <span className="col-7 text-decoration-underline">{value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Existing Probe Case details — shown read-only only when there is
                  actual probe data to show (rows with no value are dropped, and
                  the whole panel is hidden when nothing was captured). */}
              {hasProbeData && (
                <>
                  <hr/>
                  <div className="py-28 px-20">
                    <div className="row fs-5">
                      <div className="col-12 mt-3">
                        <h6 className="mb-3 d-flex align-items-center gap-1 fw-bold" style={{ color: '#d97706' }}>
                          <Icon icon="mdi:magnify-scan" /> Probe Case Details
                        </h6>
                        <div className="space-y-2">
                          {probeRows.map(({ label, icon, value }, index) => (
                            <div key={index} className="d-flex justify-content-between">
                              <span className="d-flex align-items-center gap-1 col-4 fw-bold" style={{ color: '#d97706' }}>
                                <Icon icon={icon} /> {label}
                              </span>
                              <span className="col-1">:</span>
                              <span className="col-7 text-decoration-underline">{value}</span>
                            </div>
                          ))}

                          {probeInfo.media.length > 0 && (
                            <div className="d-flex justify-content-between align-items-start">
                              <span className="d-flex align-items-center gap-1 col-4 fw-bold" style={{ color: '#d97706' }}>
                                <Icon icon="mdi:paperclip" /> Attachments
                              </span>
                              <span className="col-1">:</span>
                              <span className="col-7 d-flex flex-wrap gap-2">
                                {probeInfo.media.map((media, mIdx) => (
                                  <a
                                    key={mIdx}
                                    href={getMediaUrl(media)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-warning-600 text-white py-0 px-3 d-inline-flex align-items-center"
                                  >
                                    <Icon icon="mdi:paperclip" className="me-1" /> Attachment {mIdx + 1}
                                  </a>
                                ))}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <hr/>

              <div className="py-28 px-20">
                <div className="row fs-5">
                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Information:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Name', icon: 'mdi:account', value: formData.complainant_name },
                        { label: 'Phone Number', icon: 'mdi:phone', value: formData.complainant_contact_no },
                        { label: 'Email', icon: 'mdi:email', value: formData.complainant_email },
                        { label: 'Phone Secondary', icon: 'mdi:phone', value: formData.complainant_phone_secondry },
                        { label: 'CNIC', icon: 'mdi:id-card', value: formData.cnic },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Address:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Address', icon: 'mdi:home', value: formData.complainant_address },
                        { label: 'Tehsil', icon: 'mdi:map', value: formData.complainant_tehsil },
                        { label: 'District', icon: 'mdi:map', value: formData.complainant_district },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-24 review-action-panel">
                  <div className="scroll-sm">
                    <form onSubmit={handleSubmit}>
                      <div>
                        <div className="mb-4">
                          <div className="review-action-heading"><span><ShieldCheck size={24} weight="duotone" aria-hidden="true" /></span><div><h2>Review &amp; take action</h2><p>Choose an action and complete the required details below.</p></div></div>
                          <hr className="my-3" />
                          
                          <div className="row gy-3">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="complaintAction">
                                <Icon icon="mdi:clipboard-check" className="text-lg" />
                                Complaint Action
                              </label>
                              <RegistrationSelect
                                id="complaintAction"
                                label="Complaint Action"
                                name="complaintAction"
                                value={formDataForest.complaintAction}
                                onChange={handleChange}
                                className="form-select"
                                required
                                disabled={isSubmitting}
                              >                                
                                <option value="Resolve">Resolve Complaint</option>
                                {/* A complaint already in Probe Cases can only move to
                                    Re-Open or Resolved — hide the redundant probe option. */}
                                {formData.status !== 'Probe Cases' && (
                                  <option value="Probe Cases">Move to Probe Cases</option>
                                )}
                                <option value="Re-Open">Re-Open Complaint</option>
                              </RegistrationSelect>
                            </div>

                            {formDataForest.complaintAction === 'Resolve' && (
                              <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                <label className="form-label d-flex align-items-center gap-2" htmlFor="closeRemarks">
                                  <Icon icon="mdi:comment-text" className="text-lg" />
                                  Remarks <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  id="closeRemarks"
                                  name="closeRemarks"
                                  value={formDataForest.closeRemarks}
                                  onChange={handleChange}
                                  className="form-control"
                                  rows="4"
                                  placeholder="Enter remarks for resolving the complaint"
                                  required
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}

                            {formDataForest.complaintAction === 'Probe Cases' && (
                              <>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="inquiryDescription">
                                    <Icon icon="mdi:text-box-search-outline" className="text-lg" />
                                    Inquiry Description <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    id="inquiryDescription"
                                    name="inquiryDescription"
                                    value={formDataForest.inquiryDescription}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Describe what is being inquired / investigated"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="inquiryRemarks">
                                    <Icon icon="mdi:comment-text" className="text-lg" />
                                    Inquiry Remarks <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    id="inquiryRemarks"
                                    name="inquiryRemarks"
                                    value={formDataForest.inquiryRemarks}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="3"
                                    placeholder="Enter remarks for moving the complaint to Probe Cases"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="probeResolutionDays">
                                    <Icon icon="mdi:calendar-clock" className="text-lg" />
                                    No. of Days for resolving the Probe <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    id="probeResolutionDays"
                                    name="probeResolutionDays"
                                    type="number"
                                    min="1"
                                    step="1"
                                    value={formDataForest.probeResolutionDays}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter number of days"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>

                                {/* Optional attachment(s) with the inquiry */}
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    <Icon icon="mdi:file-upload" className="text-lg" />
                                    Attachment <span className="text-secondary-light">(optional)</span>
                                  </label>
                                  <ComplaintUploadWithImagePreviewList
                                    onFileUploadSuccess={(url) => {
                                      setInquiryMediaUrls((prev) => [...prev, url]);
                                    }}
                                  />
                                  <label className="text-sm mt-1 mb-0">Optional — upload up to 5 files (PDF, Word or JPG, max 5 MB).</label>
                                </div>
                              </>
                            )}

                            {formDataForest.complaintAction === 'Re-Open' && (
                              <>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2" htmlFor="reopenRemarks">
                                    <Icon icon="mdi:comment-text" className="text-lg" />
                                    Reopen Remarks <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    id="reopenRemarks"
                                    name="reopenRemarks"
                                    value={formDataForest.reopenRemarks}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter remarks for re-opening the complaint"
                                    required
                                    disabled={isSubmitting}
                                  />
                                </div>

                                {/* Optional attachment(s) with the re-open remarks */}
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    <Icon icon="mdi:file-upload" className="text-lg" />
                                    Attachment <span className="text-secondary-light">(optional)</span>
                                  </label>
                                  <ComplaintUploadWithImagePreviewList
                                    onFileUploadSuccess={(url) => {
                                      setReopenMediaUrls((prev) => [...prev, url]);
                                    }}
                                  />
                                  <label className="text-sm mt-1 mb-0">Optional — upload up to 5 files (PDF, Word or JPG, max 5 MB).</label>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                  <div className="card border-0 shadow-sm officer-selection-panel">
                                    <div className="card-header officer-selection-header">
                                      <h6 className="mb-0 d-flex align-items-center gap-2">
                                        <Icon icon="mdi:account-multiple-check" />
                                        Officer Checklist
                                        <span className="text-warning ms-2">*</span>
                                      </h6>
                                      <p>Choose a role or an individual officer to handle the reopened complaint.</p>
                                      <span className="officer-selection-rule">One officer per complaint</span>
                                    </div>
                                    <div className="card-body">
                                      <div className="row g-3 officer-selection-grid" role="group" aria-label="Officer selection">
                                        <div className="officer-group-heading">Select by role <small>DCF, CF and CCF require an officer selection below.</small></div>
                                        {Object.entries(officerConfig).map(([officerKey, officer]) => (
                                          <div key={officerKey} className="col-lg-3 col-md-4 col-sm-6">
                                            <div className={`form-check card border h-100 ${officerChecklist[officerKey] ? 'border-success bg-success-50' : ''}`}>
                                              <div className="card-body p-3">
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="officerSelection"
                                                  id={`officer-${officerKey}`}
                                                  checked={officerChecklist[officerKey]}
                                                  onChange={() => handleChecklistChange(officerKey)}
                                                  disabled={isSubmitting}
                                                />
                                                <label 
                                                  className="form-check-label d-flex align-items-center gap-2 w-100 h-100 officer-choice-label"
                                                  htmlFor={`officer-${officerKey}`}
                                                  style={{ cursor: 'pointer' }}
                                                >
                                                  <OfficerRoleIcon role={officerKey} />
                                                  <div>
                                                    <span className={`d-block ${officerChecklist[officerKey] ? 'fw-bold text-success' : 'text-muted'}`}>
                                                      {officer.label}
                                                    </span>
                                                  </div>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                        {unassignedDfoUsers.length > 0 && <div className="officer-group-heading officer-group-individual">Select an individual officer <small>Officers without a hierarchy assignment.</small></div>}
                                        {[...unassignedDfoUsers.filter(isDepartmentHead), ...unassignedDfoUsers.filter((officer) => !isDepartmentHead(officer))].map((officer) => <IndividualOfficerChoice key={officer._id} officer={officer} selectedId={selectedUnassignedDfoId} onChange={handleUnassignedDfoChange} disabled={isSubmitting} />)}
                                      </div>

                                      {(officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF) && (
                                        <div className="mt-3 officer-specific-picker">
                                          <label className="form-label" htmlFor="selectedOfficerId">
                                            Select {officerChecklist.DFO ? "DCF" : officerChecklist.CF ? "CF" : "CCF"}
                                            <span className="text-danger ms-1">*</span>
                                          </label>
                                          <SearchableSelect
                                            id="selectedOfficerId"
                                            options={reopenOfficers}
                                            value={selectedOfficerId}
                                            onChange={setSelectedOfficerId}
                                            getOptionValue={(officer) => officer._id}
                                            getOptionLabel={(officer) => officer.designation || ""}
                                            placeholder="Select an officer"
                                            searchPlaceholder="Search officer..."
                                            loading={isLoadingOfficers}
                                            disabled={isSubmitting || isLoadingOfficers}
                                          />
                                          {!isLoadingOfficers && reopenOfficers.length === 0 && (
                                            <small className="text-danger">No officers are available for this type.</small>
                                          )}
                                        </div>
                                      )}
                                      
                                      <div className="mt-3 p-3 bg-light rounded officer-selection-summary" aria-live="polite">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                          <Icon icon="mdi:information-outline" className="text-info" />
                                          <small className="text-muted">
                                            Selected officer: {selectedUnassignedDfoId
                                              ? (() => {
                                                  const officer = unassignedDfoUsers.find((item) => String(item._id) === selectedUnassignedDfoId);
                                                  return officer ? `${officer.first_name || ''} ${officer.last_name || ''}`.trim() || officer.designation : 'None';
                                                })()
                                              : Object.entries(officerChecklist)
                                              .filter(([_, isChecked]) => isChecked)
                                              .map(([officerKey]) => officerConfig[officerKey].label)
                                              .join(', ') || 'None'}
                                          </small>
                                        </div>
                                        {Object.values(officerChecklist).filter(Boolean).length === 0 && !selectedUnassignedDfoId && (
                                          <small className="text-danger">
                                            <Icon icon="mdi:alert-circle" className="me-1" />
                                            Please select one officer
                                          </small>
                                        )}
                                        {Object.values(officerChecklist).filter(Boolean).length > 1 && (
                                          <small className="text-danger">
                                            <Icon icon="mdi:alert-circle" className="me-1" />
                                            Only one officer can be selected at a time
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end review-submit-bar">
                        <button
                          className="btn btn-success btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-2 col-md-4 col-sm-12"
                          type="submit"
                          disabled={
                            isSubmitting ||
                            (formDataForest.complaintAction === 'Re-Open' &&
                              ((Object.values(officerChecklist).filter(Boolean).length + (selectedUnassignedDfoId ? 1 : 0)) !== 1 ||
                                ((officerChecklist.DFO || officerChecklist.CF || officerChecklist.CCF) && !selectedOfficerId)))
                          }
                        >
                          {isSubmitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {formDataForest.complaintAction === 'Resolve' ? 'Resolving...'
                                : formDataForest.complaintAction === 'Probe Cases' ? 'Saving...'
                                : 'Re-Opening...'}
                            </>
                          ) : (
                            formDataForest.complaintAction === 'Resolve' ? 'Resolve Complaint'
                              : formDataForest.complaintAction === 'Probe Cases' ? 'Move to Probe Cases'
                              : 'Re-Open Complaint'
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <ComplaintEvidenceDialog show={showAttachmentsModal} onHide={() => setShowAttachmentsModal(false)} title="Complaint Evidence" complaintNumber={formData.complaint_number} attachments={formData.media_array} />
              {(formData.status === 'Closed' || formData.status === 'Probe Cases') && latestStatusHistory && (
                <ComplaintEvidenceDialog show={showClosingEvidenceModal} onHide={() => setShowClosingEvidenceModal(false)} title="Closure Evidence" complaintNumber={formData.complaint_number} attachments={latestStatusHistory.userMediaArray} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplainFormPageCloseUpdate;
